<script setup lang="ts">
interface Props {
	class?: string;
	width?: string;
}

const props = withDefaults(defineProps<Props>(), {
	class: '',
	width: '12',
});
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="width"
		viewBox="0 0 12 13"
		fill="none"
		:class="props.class"
	>
		<path
			d="M10 3.5L4.5 9L2 6.5"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
